import AccessAPI from '../../store/AccessAPI';
import { UIConstants } from '../../shared/models/Constants';
import { BatchExecutionResult, CancelActionContext } from './MyAccessRequests.types';
import { executeSequential } from './MyAccessRequests.executor';
import { evaluateCancelEligibility } from './MyAccessRequests.lifecycleEligibility';

const toApiErrorMessage = (error: any, fallbackMessage: string): string => {
  return error?.response?.data?.message || error?.message || fallbackMessage;
};

export async function executeCancelSelected(context: CancelActionContext): Promise<BatchExecutionResult> {
  return executeSequential(context.selectedItems, {
    validate: (item) => {
      const eligibility = evaluateCancelEligibility(item);
      return eligibility.isEligible ? null : (eligibility.reason || 'Only InProgress requests can be canceled');
    },
    execute: async (item) => {
      try {
        const response = await AccessAPI.RemoveInProgressAccessRequest(item.requestId);
        if (response?.status === 200) {
          return { ok: true, message: 'Request canceled' };
        }

        return { ok: false, message: response?.message || UIConstants.Messages.RemoveFailure };
      } catch (error) {
        return { ok: false, message: toApiErrorMessage(error, UIConstants.Messages.RemoveFailure) };
      }
    },
    onSuccess: (item, message) => context.updateRowExecutionState(item.requestId, 'success', message),
    onFailure: (item, message) => context.updateRowExecutionState(item.requestId, 'failed', message)
  });
}
